import React, { Component } from 'react';
import type { ReactNode } from 'react';
import { Dropdown as AntDropdown } from 'antd';

export type DropdownType = {
  onVisibleChange: (flag: boolean) => void;
};

type Props = {
  overlay: ReactNode;
  children: ReactNode;
  overlayStyle?: any;
};

type State = {
  visible: boolean;
};

/**
 * Выпадающий список с возможностью самостоятельно
 * указывать, должен список сейчас быть открытым или нет
 */
export default class Dropdown extends Component<Props, State> {
  state: State = {
    visible: false,
  };

  /**
   * Функция, меняющая состояние (открыто/закрыто)
   * Можно вызывать через ссылку на инстанс компоненты
   */
  onVisibleChange = (flag: boolean) => {
    this.setState({
      visible: flag
    });
  };

  render() {
    const { visible } = this.state;
    const { overlay, children, overlayStyle } = this.props;
    return (
      <AntDropdown
        trigger={['click']}
        open={visible}
        popupRender={() => overlay}
        styles={{ root: overlayStyle }}
        onOpenChange={this.onVisibleChange}
      >
        {children}
      </AntDropdown>
    );
  }
}
